var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.7 1.666H9.455c-1.47 0-2.635 0-3.546.123-.938.127-1.697.393-2.296.994-.599.602-.864 1.364-.99 2.305-.123.916-.123 2.085-.123 3.56v4.865c0 1.257.767 2.334 1.856 2.786-.056-.758-.056-1.822-.056-2.706V9.418c0-1.068 0-1.988.099-2.725.105-.79.344-1.547.955-2.161.612-.614 1.366-.854 2.153-.96.734-.099 1.65-.099 2.714-.099h2.558c1.064 0 1.978 0 2.712.1A3 3 0 0 0 12.7 1.665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 9.497c0-2.272 0-3.408.703-4.113s1.834-.706 4.097-.706h2.4c2.263 0 3.394 0 4.097.705.703.706.703 1.842.703 4.114v4.016c0 2.272 0 3.408-.703 4.114-.703.705-1.834.705-4.097.705h-2.4c-2.263 0-3.394 0-4.097-.705-.703-.706-.703-1.842-.703-4.114z"
  })));
};
export default SvgCopy;